import { sleep } from '@app/utils/sleep'

import { withAbortSignal } from '@app/packages/abortContext/actions'
import { putUsersByIdPerks } from '@app/packages/api/v2/actions/users'
import { Task } from '@app/packages/task/Task'

import { profileUserSelector } from '@app/store/slices/profile'
import { setUserPerksSlice } from '@app/store/slices/users'

import { callV2Api } from './api'
import { getState } from './initial'
import { createTask } from './tasks'

export const getPerksUpdateTask = () =>
  createTask('Perks update task', dispatch =>
    Task.create(ctx => async (perks: string[], wait = 0) => {
      const state = dispatch(getState())
      const userId = profileUserSelector(state)?.id
      if (!userId) throw new Error('Profile not found')

      await sleep(wait, ctx.abortController.signal)
      const resp = await dispatch(withAbortSignal(ctx.abortController.signal, callV2Api(putUsersByIdPerks(userId, perks))))
      dispatch(
        setUserPerksSlice(
          userId,
          resp.data.map(p => p.id)
        )
      )

      return resp
    })
  )
